// Packages
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

// Actions
import { addPromotionCoupon } from "../actions/checkoutStore";

const MobileDiscountForm = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const state = useSelector((state) => state);
  const { t, i18n } = useTranslation();

  const { summary, information, urls, colors } = state.checkoutStore;
  const { isLoading, doingRequest, alertMessage } = state.ui;

  const [isSuccess, setIsSuccess] = useState(false);
  const [couponField, setCouponField] = useState("");

  useEffect(() => {
    if (location.pathname.includes("success")) {
      setIsSuccess(true);
    }
    return;
  }, [location.pathname]);

  const addPromotion = () => {
    if (couponField == "") {
      return;
    }
    setCouponField("");
    dispatch(addPromotionCoupon(couponField, information.email));
  };

  const onKeyUp = (e) => {
    if (e.charCode === 13 && !doingRequest) {
      addPromotion();
    }
  };

  const Discounts = (
    <div className="discount-div">
      <div className="mb-4">
        <label htmlFor="discount" className="label-checkout">
          {t("summary.discount-code")}
        </label>
        <div className="discount-content">
          <input
            type="text"
            className="form-control floating-label-field--s1 flex-grow-1"
            id="discount"
            disabled={doingRequest}
            placeholder="Discount Code"
            value={couponField}
            onChange={(e) => setCouponField(e.target.value)}
            onKeyPress={onKeyUp}
            style={{
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
              backgroundColor: "white",
            }}
          />
          <button
            className="btn summary-button text-nowrap"
            id="add-promo-button"
            disabled={doingRequest || couponField === ""}
            onClick={addPromotion}
            style={{
              color: "#505050",
            }}
          >
            {t("summary.apply")}
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className={`col-lg-4`}>{summary.has_promotions && Discounts}</div>
  );
};

export default MobileDiscountForm;
